import { useRelativeDateFormat } from "PFCore/hooks/use_relative_date_format";
import { useEffect, useState } from "react";

const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = 60000;
const ONE_HOUR_SEC = 3600;
const FIVE_SECONDS_MS = 5000;

type RefreshingAgoDateProps = {
  date: string;
};

export const RefreshingAgoDate = ({ date }: RefreshingAgoDateProps) => {
  const relativeDateFormat = useRelativeDateFormat();
  const [displayDate, setDisplayDate] = useState(relativeDateFormat(date));

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const refresh = () => {
      setDisplayDate(relativeDateFormat(date));

      const diff = (new Date().getTime() - new Date(date).getTime()) / ONE_SECOND_MS;
      const delay = diff > ONE_HOUR_SEC ? ONE_MINUTE_MS : FIVE_SECONDS_MS;

      timeoutId = setTimeout(refresh, delay);
    };

    refresh();

    return () => {
      clearTimeout(timeoutId);
    };
  }, [date, relativeDateFormat]);

  return <>{displayDate}</>;
};
